export enum ActionsColor {
  BLUE = 'blue',
  GREEN = 'green',
  ORANGE = 'orange',
}

export const LAYOUT_NAME_HINT_MAX_LENGTH = 24;
